import { sortDestinationIdFormat } from "@redotech/redo-model/ids";
import { SortDispositionSchema } from "@redotech/redo-model/wms/schema/sort-disposition";
import * as z from "zod";

export const createSortDestination = {
  name: "createSortDestination" as const,
  input: z.object({ name: z.string(), disposition: SortDispositionSchema }),
  output: z.object({ id: sortDestinationIdFormat.schema }),
};
